var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStripe(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "53px",
    height: "22px",
    viewBox: "0 0 53 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Stripe wordmark - slate") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Website",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Payment-details",
    transform: "translate(-917.000000, -465.000000)",
    fill: "#0A2540"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stripe-wordmark---slate",
    transform: "translate(917.000000, 465.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53,10.550055 C53,6.88888889 51.1641992,4 47.6554509,4 C44.1318977,4 42,6.88888889 42,10.5214521 C42,14.8261826 44.5168237,17 48.1292059,17 C49.8909825,17 51.2234186,16.6138614 52.230148,16.070407 L52.230148,13.210121 C51.2234186,13.6963696 50.0686406,13.9966997 48.602961,13.9966997 C47.166891,13.9966997 45.8936743,13.510451 45.730821,11.8228823 L52.9703903,11.8228823 C52.9703903,11.6369637 53,10.8932893 53,10.550055 Z M45.6864065,9.19141914 C45.6864065,7.57535754 46.7079408,6.90319032 47.640646,6.90319032 C48.5437416,6.90319032 49.5060565,7.57535754 49.5060565,9.19141914 L45.6864065,9.19141914 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6857143,4 C35.1584416,4 34.1766234,4.70050761 33.6311688,5.18781726 L33.4285714,4.24365482 L30,4.24365482 L30,22 L33.8961039,21.1928934 L33.9116883,16.8832487 C34.4727273,17.2791878 35.2987013,17.8426396 36.6701299,17.8426396 C39.4597403,17.8426396 42,15.6497462 42,10.822335 C41.9844156,6.40609137 39.412987,4 36.6857143,4 Z M35.7506494,14.4923858 C34.8311688,14.4923858 34.2857143,14.1725888 33.9116883,13.7766497 L33.8961039,8.12690355 C34.3012987,7.68527919 34.8623377,7.38071066 35.7506494,7.38071066 C37.1688312,7.38071066 38.1506494,8.93401015 38.1506494,10.928934 C38.1506494,12.9695431 37.1844156,14.4923858 35.7506494,14.4923858 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "25 4 29 3.15953307 29 0 25 0.824902724"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 25,
    y: 5,
    width: 4,
    height: 13
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6909091,6.23837117 L20.4363636,5.15177875 L17,5.15177875 L17,18 L20.9772727,18 L20.9772727,9.29257691 C21.9159091,8.16193344 23.5068182,8.36750498 24,8.52902548 L24,5.15177875 C23.4909091,4.97557457 21.6295455,4.65253358 20.6909091,6.23837117 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9516129,2 L10.016129,2.74954955 L10,14.2954955 C10,16.4288288 11.7903226,18 14.1774194,18 C15.5,18 16.4677419,17.7837838 17,17.5243243 L17,14.5981982 C16.483871,14.7855856 13.9354839,15.4486486 13.9354839,13.3153153 L13.9354839,8.1981982 L17,8.1981982 L17,5.12792793 L13.9354839,5.12792793 L13.9516129,2 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.58582677,7.87142857 C3.58582677,7.31428571 4.03937008,7.1 4.79055118,7.1 C5.86771654,7.1 7.22834646,7.42857143 8.30551181,8.01428571 L8.30551181,4.65714286 C7.12913386,4.18571429 5.96692913,4 4.79055118,4 C1.91338583,4 0,5.51428571 0,8.04285714 C0,11.9857143 5.38582677,11.3571429 5.38582677,13.0571429 C5.38582677,13.7142857 4.81889764,13.9285714 4.02519685,13.9285714 C2.8488189,13.9285714 1.34645669,13.4428571 0.155905512,12.7857143 L0.155905512,16.1857143 C1.47401575,16.7571429 2.80629921,17 4.02519685,17 C6.97322835,17 9,15.5285714 9,12.9714286 C8.98582677,8.71428571 3.58582677,9.47142857 3.58582677,7.87142857 Z",
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStripe);
export default __webpack_public_path__ + "static/media/stripe.c8ead92418df7b693aa6dd17eb1be666.svg";
export { ForwardRef as ReactComponent };